import React from 'react';

const doParse = (markdown) => {
  const LINES = markdown.split('\n');
  const ELEMENTS = [];

  let inList = false; // Track if we are currently inside a list
  let inNestedList = false; // Track if we are inside a nested list
  let isCurrentListLevel = 0; // Track the current nesting level of lists

  LINES.forEach((LINE, INDEX) => {
    LINE = LINE.trim(); // Trim whitespace from the beginning and end of the line

    if (LINE.startsWith('* ')) {
      // Top-level list item
      if (!inList) {
        ELEMENTS.push('<ul>'); // Start the outermost list
        inList = true;
      }
      if (inNestedList) {
        // Close the previous nested list
        ELEMENTS.push('</ul>');
        inNestedList = false;
        isCurrentListLevel--;
      }
      ELEMENTS.push(`<li key=${INDEX}>${LINE.substring(2)}</li>`);
    } else if (LINE.startsWith('**')) {
      // Nested list item
      if (!inNestedList) {
        ELEMENTS.push('<ul>'); // Start a nested list
        inNestedList = true;
        isCurrentListLevel++;
      }
      ELEMENTS.push(`<li key=${INDEX}>${LINE.substring(2)}</li>`);
    } else {
      // Non-list item
      if (inList) {
        if (inNestedList) {
          ELEMENTS.push('</ul>'); // Close any open nested list
          inNestedList = false;
          isCurrentListLevel--;
        }
        ELEMENTS.push('</ul>'); // Close the outermost list
        inList = false;
      }
      ELEMENTS.push(`<span key=${INDEX}>${LINE}</span>`);
    }
  });

  if (inNestedList) {
    ELEMENTS.push('</ul>'); // Close any remaining open nested list
  } else if (inList) {
    ELEMENTS.push('</ul>'); // Close the outermost list
  }

  return ELEMENTS.join(''); // Join all elements into a single string
};


const MarkdownRenderer = ({ className, markdown }) => {
  if (!markdown) return null;
  const elements = doParse(markdown);
  return <div className={className} dangerouslySetInnerHTML={{ __html: elements }}/>;
};

export default MarkdownRenderer;
